<template>
    <div
        class="detailsContainer d-flex flex-column offcanvas offcanvas-start"
        tabindex="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
    >
        <div class="d-flex flex-column gap-3 mb-3">
            <div
                v-for="item in [1, 2, 3, 4]"
                :key="item"
                class="d-flex justify-content-between flex-row"
            >
                <div class="skeleton h-35 w-35"></div>
                <div class="skeleton h-35 w-35"></div>
            </div>
        </div>
        <div class="orderItemSkeleton d-flex flex-row gap-3 mb-3">
            <div class="skeleton align-self-center rounded itemSkeleton"></div>
            <div class="d-flex flex-column gap-1">
                <div class="skeleton h-35 w-100"></div>
                <div class="skeleton h-35 w-100"></div>
                <div class="skeleton h-35 w-100"></div>
            </div>
            <div class="skeleton itemSkeleton mt-auto"></div>
        </div>
        <div class="d-flex flex-column mt-auto gap-3">
            <div class="skeleton h-35 w-100 mb-3"></div>
            <div
                v-for="item in [1, 2, 3, 4]"
                :key="item"
                class="d-flex justify-content-between flex-row"
            >
                <div class="skeleton h-35 w-35"></div>
                <div class="skeleton h-35 w-35"></div>
            </div>
            <div class="skeleton h-35 w-100 mt-3"></div>
        </div>
    </div>
</template>

<script setup></script>

<style scoped lang="scss">
@import "../styles/orderDetailsSkeleton.scss";
</style>
